import '@/assets/icons/index' // svg图标文件导入
const components = {}
let files = require.context('@/components', true, /\.vue$/)
files.keys().forEach(key=>{
    components[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default
})
const component = {
    install: (Vue) => {
        for(let key in components) {
            Vue.component(components[key].name, components[key])
        }
    }
}
// // 导出该组件
export default component